import React from "react";

const APP_STORE_URL = "https://apps.apple.com/us/app/carivisor/id6806723154";
// Placeholder until the Google Play review finishes.
const PLAY_STORE_URL = "#";

const AppleIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M16.365 1.43c0 1.14-.417 2.2-1.11 2.98-.75.85-1.98 1.5-3.02 1.42-.13-1.1.42-2.27 1.08-3.02.74-.85 2.03-1.47 3.05-1.5.02.04.02.08 0 .12zM20.5 17.03c-.53 1.22-.78 1.77-1.46 2.85-.95 1.5-2.29 3.36-3.95 3.38-1.47.01-1.85-.96-3.85-.95-2 .01-2.42.97-3.9.95-1.66-.02-2.93-1.7-3.88-3.2-2.65-4.19-2.93-9.11-1.29-11.72 1.16-1.85 3-2.94 4.72-2.94 1.76 0 2.86 1 4.31 1 1.41 0 2.27-1 4.3-1 1.54 0 3.17.84 4.33 2.28-3.8 2.08-3.18 7.5.57 8.1z" />
  </svg>
);

const PlayIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
    <path d="M3.6 2.3c-.3.2-.5.6-.5 1.1v17.2c0 .5.2.9.5 1.1l.1.1L13 12.6v-.2L3.7 2.2l-.1.1z" fill="#00D4FF" />
    <path d="M16.3 15.9l-3.3-3.3v-.2l3.3-3.3.1.1 3.9 2.2c1.1.6 1.1 1.7 0 2.3l-3.9 2.2-.1.1z" fill="#FFCE00" />
    <path d="M16.4 15.8L13 12.4 3.6 21.8c.4.4 1 .4 1.7.1l11.1-6.1z" fill="#FF3D47" />
    <path d="M16.4 9L5.3 2.9c-.7-.4-1.3-.3-1.7.1L13 12.4 16.4 9z" fill="#00F076" />
  </svg>
);

const Badge = ({ href, testid, icon: Icon, top, bottom, iconClass = "" }) => (
  <a
    href={href}
    target={href === "#" ? undefined : "_blank"}
    rel="noreferrer"
    data-testid={testid}
    title={href === "#" ? `${bottom} — coming soon` : `${top} ${bottom}`}
    className="flex items-center gap-1.5 h-9 px-2.5 rounded-lg bg-black border border-white/15 hover:border-white/40 transition-colors"
  >
    <Icon className={`w-4 h-4 text-white shrink-0 ${iconClass}`} />
    <span className="flex flex-col leading-none text-left">
      <span className="text-[7px] text-slate-300 uppercase tracking-tight whitespace-nowrap">{top}</span>
      <span className="text-[11px] text-white font-semibold -mt-0.5 whitespace-nowrap">{bottom}</span>
    </span>
  </a>
);

export function StoreBadges({ className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="store-badges">
      <Badge href={APP_STORE_URL} testid="app-store-badge" icon={AppleIcon} top="Download on the" bottom="App Store" />
      <Badge href={PLAY_STORE_URL} testid="google-play-badge" icon={PlayIcon} top="Get it on" bottom="Google Play" />
    </div>
  );
}

export default StoreBadges;
